var cov_d73qpd06i = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Form/Item.tsx",
      hash = "61efd664932b57f778c3e16d3183218573783985",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Form/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 31
        },
        end: {
          line: 13,
          column: 99
        }
      },
      "1": {
        start: {
          line: 20,
          column: 32
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "2": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 43
        }
      },
      "3": {
        start: {
          line: 21,
          column: 32
        },
        end: {
          line: 21,
          column: 43
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "5": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 16
        }
      },
      "6": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "7": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "8": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 52
        }
      },
      "9": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 82
        }
      },
      "10": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 82
        }
      },
      "11": {
        start: {
          line: 67,
          column: 26
        },
        end: {
          line: 67,
          column: 36
        }
      },
      "12": {
        start: {
          line: 68,
          column: 28
        },
        end: {
          line: 68,
          column: 30
        }
      },
      "13": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "14": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 74,
          column: 8
        }
      },
      "15": {
        start: {
          line: 72,
          column: 20
        },
        end: {
          line: 72,
          column: 44
        }
      },
      "16": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 33
        }
      },
      "17": {
        start: {
          line: 73,
          column: 17
        },
        end: {
          line: 73,
          column: 33
        }
      },
      "18": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "19": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 31
        }
      },
      "20": {
        start: {
          line: 78,
          column: 15
        },
        end: {
          line: 78,
          column: 31
        }
      },
      "21": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 17
        }
      },
      "22": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 56
        }
      },
      "23": {
        start: {
          line: 85,
          column: 26
        },
        end: {
          line: 85,
          column: 56
        }
      },
      "24": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "25": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 24
        }
      },
      "26": {
        start: {
          line: 92,
          column: 18
        },
        end: {
          line: 92,
          column: 53
        }
      },
      "27": {
        start: {
          line: 93,
          column: 26
        },
        end: {
          line: 93,
          column: 36
        }
      },
      "28": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "29": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 97,
          column: 8
        }
      },
      "30": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 65
        }
      },
      "31": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "32": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 104,
          column: 10
        }
      },
      "33": {
        start: {
          line: 103,
          column: 10
        },
        end: {
          line: 103,
          column: 32
        }
      },
      "34": {
        start: {
          line: 110,
          column: 18
        },
        end: {
          line: 110,
          column: 53
        }
      },
      "35": {
        start: {
          line: 111,
          column: 26
        },
        end: {
          line: 111,
          column: 36
        }
      },
      "36": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "37": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 115,
          column: 8
        }
      },
      "38": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 48
        }
      },
      "39": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "40": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 122,
          column: 10
        }
      },
      "41": {
        start: {
          line: 121,
          column: 10
        },
        end: {
          line: 121,
          column: 32
        }
      },
      "42": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "43": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 34
        }
      },
      "44": {
        start: {
          line: 136,
          column: 23
        },
        end: {
          line: 136,
          column: 52
        }
      },
      "45": {
        start: {
          line: 136,
          column: 42
        },
        end: {
          line: 136,
          column: 51
        }
      },
      "46": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "47": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 144,
          column: 7
        }
      },
      "48": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 42
        }
      },
      "49": {
        start: {
          line: 147,
          column: 20
        },
        end: {
          line: 147,
          column: 30
        }
      },
      "50": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 25
        }
      },
      "51": {
        start: {
          line: 148,
          column: 14
        },
        end: {
          line: 148,
          column: 25
        }
      },
      "52": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 56
        }
      },
      "53": {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 18
        }
      },
      "54": {
        start: {
          line: 165,
          column: 19
        },
        end: {
          line: 165,
          column: 35
        }
      },
      "55": {
        start: {
          line: 166,
          column: 22
        },
        end: {
          line: 177,
          column: 5
        }
      },
      "56": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 189,
          column: 5
        }
      },
      "57": {
        start: {
          line: 196,
          column: 29
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "58": {
        start: {
          line: 196,
          column: 103
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "59": {
        start: {
          line: 197,
          column: 2
        },
        end: {
          line: 197,
          column: 80
        }
      },
      "60": {
        start: {
          line: 197,
          column: 30
        },
        end: {
          line: 197,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 32
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 71,
            column: 45
          },
          end: {
            line: 71,
            column: 46
          }
        },
        loc: {
          start: {
            line: 71,
            column: 53
          },
          end: {
            line: 74,
            column: 7
          }
        },
        line: 71
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 77,
            column: 44
          },
          end: {
            line: 77,
            column: 45
          }
        },
        loc: {
          start: {
            line: 77,
            column: 51
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 77
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 17
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 84
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 34
          },
          end: {
            line: 86,
            column: 35
          }
        },
        loc: {
          start: {
            line: 86,
            column: 40
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 86
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 21
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 21
          }
        },
        loc: {
          start: {
            line: 95,
            column: 25
          },
          end: {
            line: 97,
            column: 7
          }
        },
        line: 95
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 101,
            column: 12
          },
          end: {
            line: 101,
            column: 13
          }
        },
        loc: {
          start: {
            line: 101,
            column: 21
          },
          end: {
            line: 105,
            column: 7
          }
        },
        line: 101
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 102,
            column: 22
          },
          end: {
            line: 102,
            column: 23
          }
        },
        loc: {
          start: {
            line: 102,
            column: 27
          },
          end: {
            line: 104,
            column: 9
          }
        },
        line: 102
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 23
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 109
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 113,
            column: 20
          },
          end: {
            line: 113,
            column: 21
          }
        },
        loc: {
          start: {
            line: 113,
            column: 25
          },
          end: {
            line: 115,
            column: 7
          }
        },
        line: 113
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 119,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        },
        loc: {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 123,
            column: 7
          }
        },
        line: 119
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 120,
            column: 22
          },
          end: {
            line: 120,
            column: 23
          }
        },
        loc: {
          start: {
            line: 120,
            column: 27
          },
          end: {
            line: 122,
            column: 9
          }
        },
        line: 120
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 42
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 127
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 129,
            column: 12
          },
          end: {
            line: 129,
            column: 13
          }
        },
        loc: {
          start: {
            line: 129,
            column: 21
          },
          end: {
            line: 131,
            column: 7
          }
        },
        line: 129
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 135,
            column: 3
          }
        },
        loc: {
          start: {
            line: 135,
            column: 30
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 135
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 136,
            column: 37
          },
          end: {
            line: 136,
            column: 38
          }
        },
        loc: {
          start: {
            line: 136,
            column: 42
          },
          end: {
            line: 136,
            column: 51
          }
        },
        line: 136
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 140,
            column: 26
          },
          end: {
            line: 140,
            column: 27
          }
        },
        loc: {
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 141,
            column: 42
          }
        },
        line: 141
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 152,
            column: 2
          },
          end: {
            line: 152,
            column: 3
          }
        },
        loc: {
          start: {
            line: 152,
            column: 11
          },
          end: {
            line: 190,
            column: 3
          }
        },
        line: 152
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 196,
            column: 29
          },
          end: {
            line: 196,
            column: 30
          }
        },
        loc: {
          start: {
            line: 196,
            column: 103
          },
          end: {
            line: 198,
            column: 1
          }
        },
        line: 196
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 196,
            column: 103
          },
          end: {
            line: 196,
            column: 104
          }
        },
        loc: {
          start: {
            line: 196,
            column: 114
          },
          end: {
            line: 198,
            column: 1
          }
        },
        line: 196
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 197,
            column: 20
          },
          end: {
            line: 197,
            column: 21
          }
        },
        loc: {
          start: {
            line: 197,
            column: 30
          },
          end: {
            line: 197,
            column: 68
          }
        },
        line: 197
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 43
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 43
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 82
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 82
          }
        }],
        line: 63
      },
      "2": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 70
      },
      "3": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 33
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 33
          }
        }],
        line: 73
      },
      "4": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 31
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 31
          }
        }],
        line: 78
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 56
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 56
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 18
          },
          end: {
            line: 92,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 40
          },
          end: {
            line: 92,
            column: 44
          }
        }, {
          start: {
            line: 92,
            column: 47
          },
          end: {
            line: 92,
            column: 53
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }],
        line: 94
      },
      "8": {
        loc: {
          start: {
            line: 110,
            column: 18
          },
          end: {
            line: 110,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 110,
            column: 40
          },
          end: {
            line: 110,
            column: 44
          }
        }, {
          start: {
            line: 110,
            column: 47
          },
          end: {
            line: 110,
            column: 53
          }
        }],
        line: 110
      },
      "9": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 112
      },
      "10": {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 137
      },
      "11": {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 25
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 25
          }
        }],
        line: 148
      },
      "12": {
        loc: {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 16
          }
        }, {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 170,
            column: 30
          }
        }],
        line: 170
      },
      "13": {
        loc: {
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 171,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 171,
            column: 25
          }
        }, {
          start: {
            line: 171,
            column: 29
          },
          end: {
            line: 171,
            column: 38
          }
        }],
        line: 171
      },
      "14": {
        loc: {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 172,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 172,
            column: 26
          }
        }, {
          start: {
            line: 172,
            column: 30
          },
          end: {
            line: 172,
            column: 74
          }
        }],
        line: 172
      },
      "15": {
        loc: {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 23
          }
        }, {
          start: {
            line: 173,
            column: 27
          },
          end: {
            line: 173,
            column: 45
          }
        }],
        line: 173
      },
      "16": {
        loc: {
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 63
          }
        }, {
          start: {
            line: 174,
            column: 67
          },
          end: {
            line: 174,
            column: 94
          }
        }],
        line: 174
      },
      "17": {
        loc: {
          start: {
            line: 174,
            column: 41
          },
          end: {
            line: 174,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 41
          },
          end: {
            line: 174,
            column: 51
          }
        }, {
          start: {
            line: 174,
            column: 55
          },
          end: {
            line: 174,
            column: 57
          }
        }],
        line: 174
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Form/Item.tsx",
    _this5 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import immer from 'immer';
import createReactContext from '../context';
import { Component } from '../component';
import { errorSubscribe, RESET_TOPIC } from '../Datum/types';
import { getGrid } from '../Grid/utils';
import { objectValues } from '../utils/objects';
import { formClass } from './styles';

var _ref = (cov_d73qpd06i.s[0]++, createReactContext({})),
    Provider = _ref.Provider,
    Consumer = _ref.Consumer;

var Label =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Label, _PureComponent);

  var _super = _createSuper2(Label);

  function Label() {
    _classCallCheck(this, Label);

    return _super.apply(this, arguments);
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      cov_d73qpd06i.f[0]++;

      var _ref2 = (cov_d73qpd06i.s[1]++, this.props),
          width = _ref2.width,
          children = _ref2.children;

      cov_d73qpd06i.s[2]++;

      if (children === undefined) {
        cov_d73qpd06i.b[0][0]++;
        cov_d73qpd06i.s[3]++;
        return null;
      } else {
        cov_d73qpd06i.b[0][1]++;
      }

      cov_d73qpd06i.s[4]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            width: width
          },
          className: formClass('label'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 7
          }
        }, children)
      );
    }
  }]);

  return Label;
}(PureComponent);

// eslint-disable-next-line
var Item =
/*#__PURE__*/
function (_Component) {
  _inherits(Item, _Component);

  var _super2 = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    cov_d73qpd06i.f[1]++;
    cov_d73qpd06i.s[5]++;
    _this = _super2.call(this, props);
    _this.events = void 0;
    _this.updateTimer = void 0;
    cov_d73qpd06i.s[6]++;
    _this.state = {
      inputs: {},
      errors: {}
    };
    cov_d73qpd06i.s[7]++;
    _this.events = {
      bindInputToItem: _this.bind.bind(_assertThisInitialized(_this)),
      unbindInputFromItem: _this.unbind.bind(_assertThisInitialized(_this)),
      onItemError: _this.handleError.bind(_assertThisInitialized(_this))
    };
    cov_d73qpd06i.s[8]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    cov_d73qpd06i.s[9]++;

    if (props.formDatum) {
      cov_d73qpd06i.b[1][0]++;
      cov_d73qpd06i.s[10]++;
      props.formDatum.subscribe(RESET_TOPIC, _this.handleUpdate);
    } else {
      cov_d73qpd06i.b[1][1]++;
    }

    return _this;
  }

  _createClass(Item, [{
    key: "getErrors",
    value: function getErrors() {
      cov_d73qpd06i.f[2]++;

      var _ref3 = (cov_d73qpd06i.s[11]++, this.props),
          formDatum = _ref3.formDatum;

      var errors = (cov_d73qpd06i.s[12]++, []);
      cov_d73qpd06i.s[13]++;

      if (formDatum) {
        cov_d73qpd06i.b[2][0]++;
        cov_d73qpd06i.s[14]++;
        Object.keys(this.state.inputs).forEach(function (name) {
          cov_d73qpd06i.f[3]++;
          var err = (cov_d73qpd06i.s[15]++, formDatum.getError(name));
          cov_d73qpd06i.s[16]++;

          if (err) {
            cov_d73qpd06i.b[3][0]++;
            cov_d73qpd06i.s[17]++;
            errors.push(err);
          } else {
            cov_d73qpd06i.b[3][1]++;
          }
        });
      } else {
        cov_d73qpd06i.b[2][1]++;
      }

      cov_d73qpd06i.s[18]++;
      objectValues(this.state.errors).forEach(function (err) {
        cov_d73qpd06i.f[4]++;
        cov_d73qpd06i.s[19]++;

        if (err) {
          cov_d73qpd06i.b[4][0]++;
          cov_d73qpd06i.s[20]++;
          errors.push(err);
        } else {
          cov_d73qpd06i.b[4][1]++;
        }
      });
      cov_d73qpd06i.s[21]++;
      return errors;
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      var _this2 = this;

      cov_d73qpd06i.f[5]++;
      cov_d73qpd06i.s[22]++;

      if (this.updateTimer) {
        cov_d73qpd06i.b[5][0]++;
        cov_d73qpd06i.s[23]++;
        clearTimeout(this.updateTimer);
      } else {
        cov_d73qpd06i.b[5][1]++;
      }

      cov_d73qpd06i.s[24]++;
      this.updateTimer = setTimeout(function () {
        cov_d73qpd06i.f[6]++;
        cov_d73qpd06i.s[25]++;

        _this2.forceUpdate();
      });
    }
  }, {
    key: "bind",
    value: function bind(name) {
      var _this3 = this;

      cov_d73qpd06i.f[7]++;
      var names = (cov_d73qpd06i.s[26]++, Array.isArray(name) ? (cov_d73qpd06i.b[6][0]++, name) : (cov_d73qpd06i.b[6][1]++, [name]));

      var _ref4 = (cov_d73qpd06i.s[27]++, this.props),
          formDatum = _ref4.formDatum;

      cov_d73qpd06i.s[28]++;

      if (formDatum) {
        cov_d73qpd06i.b[7][0]++;
        cov_d73qpd06i.s[29]++;
        names.forEach(function (n) {
          cov_d73qpd06i.f[8]++;
          cov_d73qpd06i.s[30]++;
          formDatum.subscribe(errorSubscribe(n), _this3.handleUpdate);
        });
      } else {
        cov_d73qpd06i.b[7][1]++;
      }

      cov_d73qpd06i.s[31]++;
      this.setState(immer(function (state) {
        cov_d73qpd06i.f[9]++;
        cov_d73qpd06i.s[32]++;
        names.forEach(function (n) {
          cov_d73qpd06i.f[10]++;
          cov_d73qpd06i.s[33]++;
          state.inputs[n] = true;
        });
      }));
    }
  }, {
    key: "unbind",
    value: function unbind(name) {
      cov_d73qpd06i.f[11]++;
      var names = (cov_d73qpd06i.s[34]++, Array.isArray(name) ? (cov_d73qpd06i.b[8][0]++, name) : (cov_d73qpd06i.b[8][1]++, [name]));

      var _ref5 = (cov_d73qpd06i.s[35]++, this.props),
          formDatum = _ref5.formDatum;

      cov_d73qpd06i.s[36]++;

      if (formDatum) {
        cov_d73qpd06i.b[9][0]++;
        cov_d73qpd06i.s[37]++;
        names.forEach(function (n) {
          cov_d73qpd06i.f[12]++;
          cov_d73qpd06i.s[38]++;
          formDatum.unsubscribe(errorSubscribe(n));
        });
      } else {
        cov_d73qpd06i.b[9][1]++;
      }

      cov_d73qpd06i.s[39]++;
      this.setState(immer(function (state) {
        cov_d73qpd06i.f[13]++;
        cov_d73qpd06i.s[40]++;
        names.forEach(function (n) {
          cov_d73qpd06i.f[14]++;
          cov_d73qpd06i.s[41]++;
          delete state.inputs[n];
        });
      }));
    }
  }, {
    key: "handleError",
    value: function handleError(name, error) {
      cov_d73qpd06i.f[15]++;
      cov_d73qpd06i.s[42]++;
      this.setState(immer(function (state) {
        cov_d73qpd06i.f[16]++;
        cov_d73qpd06i.s[43]++;
        state.errors[name] = error;
      }));
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(errors) {
      var _this4 = this;

      cov_d73qpd06i.f[17]++;
      var realErrors = (cov_d73qpd06i.s[44]++, errors.filter(function (e) {
        cov_d73qpd06i.f[18]++;
        cov_d73qpd06i.s[45]++;
        return e.message;
      }));
      cov_d73qpd06i.s[46]++;

      if (realErrors.length > 0) {
        cov_d73qpd06i.b[10][0]++;
        cov_d73qpd06i.s[47]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: formClass('error'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 139,
              columnNumber: 9
            }
          }, realErrors.map(function (e, i) {
            cov_d73qpd06i.f[19]++;
            cov_d73qpd06i.s[48]++;
            return (
              /*#__PURE__*/
              React.createElement("div", {
                key: i,
                __self: _this4,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 141,
                  columnNumber: 13
                }
              }, e.message)
            );
          }))
        );
      } else {
        cov_d73qpd06i.b[10][1]++;
      }

      var _ref6 = (cov_d73qpd06i.s[49]++, this.props),
          tip = _ref6.tip;

      cov_d73qpd06i.s[50]++;

      if (!tip) {
        cov_d73qpd06i.b[11][0]++;
        cov_d73qpd06i.s[51]++;
        return null;
      } else {
        cov_d73qpd06i.b[11][1]++;
      }

      cov_d73qpd06i.s[52]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('tip'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 149,
            columnNumber: 12
          }
        }, tip)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_d73qpd06i.f[20]++;

      var _ref7 = (cov_d73qpd06i.s[53]++, this.props),
          children = _ref7.children,
          grid = _ref7.grid,
          label = _ref7.label,
          labelAlign = _ref7.labelAlign,
          labelVerticalAlign = _ref7.labelVerticalAlign,
          labelWidth = _ref7.labelWidth,
          required = _ref7.required,
          style = _ref7.style,
          keepErrorHeight = _ref7.keepErrorHeight;

      var errors = (cov_d73qpd06i.s[54]++, this.getErrors());
      var className = (cov_d73qpd06i.s[55]++, classnames(getGrid(grid), formClass('item', (cov_d73qpd06i.b[12][0]++, required) && (cov_d73qpd06i.b[12][1]++, 'required'), (cov_d73qpd06i.b[13][0]++, errors.length > 0) && (cov_d73qpd06i.b[13][1]++, 'invalid'), (cov_d73qpd06i.b[14][0]++, labelVerticalAlign) && (cov_d73qpd06i.b[14][1]++, "label-vertical-align-".concat(labelVerticalAlign)), (cov_d73qpd06i.b[15][0]++, keepErrorHeight) && (cov_d73qpd06i.b[15][1]++, "item-keep-height"), (cov_d73qpd06i.b[16][0]++, ['top', 'right', 'left'].indexOf((cov_d73qpd06i.b[17][0]++, labelAlign) || (cov_d73qpd06i.b[17][1]++, '')) >= 0) && (cov_d73qpd06i.b[16][1]++, "label-align-".concat(labelAlign))), this.props.className));
      cov_d73qpd06i.s[56]++;
      return (
        /*#__PURE__*/
        React.createElement(Provider, {
          value: this.events,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 180,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 181,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Label, {
          width: labelWidth,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 182,
            columnNumber: 11
          }
        }, label),
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('control'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 183,
            columnNumber: 11
          }
        }, children, this.renderHelp(errors))))
      );
    }
  }]);

  return Item;
}(Component);

Item.defaultProps = {
  className: '',
  style: {},
  formItemErrors: [],
  keepErrorHeight: false
};
export default Item; // eslint-disable-next-line

cov_d73qpd06i.s[57]++;
export var itemConsumer = function itemConsumer(Origin) {
  cov_d73qpd06i.f[21]++;
  cov_d73qpd06i.s[58]++;
  return function (props) {
    cov_d73qpd06i.f[22]++;
    cov_d73qpd06i.s[59]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this5,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 10
        }
      }, function (events) {
        cov_d73qpd06i.f[23]++;
        cov_d73qpd06i.s[60]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, events, {
            __self: _this5,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 197,
              columnNumber: 31
            }
          }))
        );
      })
    );
  };
};